import { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api' 
import { ACCESS_TOKEN } from '../../common/util' 

function useUpdateProgram() { 
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const updateProgram = async (formData:any) => {
        try {
            const response = await axios.put(`${baseUrl}/program/update-program`,formData, {
                headers: {
                  'Content-Type': "multipart/form-data",
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });
            
            return response.status;
        } catch (error) {
            console.error(error);
        }
    };

    return { updateProgram };
}

export default useUpdateProgram;
